export default __webpack_public_path__ + "static/media/bg-img-getting-started.40116bcf.jpg";